import React from "react";
import brands1 from '../assets/images/brands1.jpg';
import { Link } from "react-router-dom";
import logo from '../assets/images/logo.svg';
import Footer from "./Footer";
import TopNav from "./TopNav";

const KhatmQoranSingle = () => {
    return (
        <>
            <header>
                <div className="pagewrapper slim2" id="header-slim">
                    <div className="container">
                        <TopNav />
                    </div>
                </div>
            </header>
            <div className="clear" />
            <div className="pagewrapper">
                <div className="container">
                    <h1 id="khatm-single-main-title">ختم 4 جزء قرآن کریم</h1>
                </div>
            </div>
            <div className="pagewrapper" id="statistics">
                <div className="container">
                    <div className="right-col">
                        <div className="stat-item box-sizing">
                            <span>--</span>
                            افراد دخیل
                        </div>
                        <div className="stat-item border0 box-sizing">
                            <span>500</span>
                            خوانده شده
                        </div>
                    </div>
                    <div className="pinbar" />
                    <div className="left-col">
                        <div className="stat-item box-sizing">
                            <span>250</span>
                            مانده
                        </div>
                        <div className="stat-item box-sizing">
                            <span>25</span>
                            افراد وارد شده
                        </div>
                    </div>
                </div>
            </div>
            <div className="pagewrapper" id="khatm-hajat">
                <div className="container">
                    <h2 className="hajat-title">حاجت از ختم</h2>
                    <p className="hajat-text box-sizing radius10">
                        شفای عاجل تمام بیماران سرطانی علی الخصوص آقای محمد محمدی
                    </p>
                </div>
            </div>
            <div className="pagewrapper" id="khatm-ghoran-player">
                <div className="container">
                    <h2 className="main-title">قرائت 4 جزء</h2>
                    <ul className="khatm-player-list">
                        <li className="item box-sizing radius10">
                            <h3 className="title">جزء یک</h3>
                            <audio controls>
                                <source src="horse.ogg" type="audio/ogg" />
                                <source src="horse.mp3" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <a href title className="btn radius10 ease box-sizing">تقبل قرائت جزء یک</a>
                            <select name="ghaari" className="select blue radius10 box-sizing ease">
                                <option value={-1}>انتخاب قاری</option>
                                <option value="محمد احمدی">محمد احمدی</option>
                                <option value="علی صادقی">علی صادقی</option>
                                <option value="بنیامین اکبری">بنیامین اکبری</option>
                            </select>
                        </li>
                        <li className="item box-sizing radius10">
                            <h3 className="title">جزء دو</h3>
                            <audio controls>
                                <source src="horse.ogg" type="audio/ogg" />
                                <source src="horse.mp3" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <a href title className="btn radius10 ease box-sizing">تقبل قرائت جزء دو</a>
                            <select name="ghaari" className="select blue radius10 box-sizing ease">
                                <option value={-1}>انتخاب قاری</option>
                                <option value="محمد احمدی">محمد احمدی</option>
                                <option value="علی صادقی">علی صادقی</option>
                                <option value="بنیامین اکبری">بنیامین اکبری</option>
                            </select>
                        </li>
                        <li className="item box-sizing radius10">
                            <h3 className="title">جزء سه</h3>
                            <audio controls>
                                <source src="horse.ogg" type="audio/ogg" />
                                <source src="horse.mp3" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <a href title className="btn radius10 ease box-sizing">تقبل قرائت جزء سه</a>
                            <select name="ghaari" className="select blue radius10 box-sizing ease">
                                <option value={-1}>انتخاب قاری</option>
                                <option value="محمد احمدی">محمد احمدی</option>
                                <option value="علی صادقی">علی صادقی</option>
                                <option value="بنیامین اکبری">بنیامین اکبری</option>
                            </select>
                        </li>
                        <li className="item box-sizing radius10 disable">
                            <h3 className="title">جزء چهار</h3>
                            <audio controls>
                                <source src="horse.ogg" type="audio/ogg" />
                                <source src="horse.mp3" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <a href title className="btn radius10 ease box-sizing">تقبل قرائت جزء چهار</a>
                            <select name="ghaari" className="select blue radius10 box-sizing ease">
                                <option value={-1}>انتخاب قاری</option>
                                <option value="محمد احمدی">محمد احمدی</option>
                                <option value="علی صادقی">علی صادقی</option>
                                <option value="بنیامین اکبری">بنیامین اکبری</option>
                            </select>
                        </li>
                    </ul>
                    <div className="clear" />
                </div>
            </div>
            <div className="clear" />
            <Footer />
        </>
    );
}

export default KhatmQoranSingle;